import axios from 'axios';
import {API_URL_PREFIX, axiosAuthHeader, axiosErrorHandler} from "./axios.utils";

const API_URL = API_URL_PREFIX + '/v1/venues';

class VenuesService {
    // no header needed
    getVenues(search, actType, slot) {
        let url = API_URL + "?offset=0&limit=100&include_total=true&order_by=%2Dupdated_time";
        if (search != null && search !== "") {
            url += "&search=" + search;
        }
        if (actType != null && actType !== "") {
            url += "&s_preferred_act_types__ilike=%" + actType + "%";
        }
        if (slot != null && slot !== "") {
            let pieces = slot.split(":")
            url += "&available_slots__slot_def=" + pieces[0] + "&available_slots__available_to_schedule=" + pieces[1];
        }
        console.log("url=" + JSON.stringify(url))
        return axios.get(url).catch(function (error) {
            axiosErrorHandler(error);
        });
    }

    // no header needed
    getVenueById(venue_id) {
        return axios.get(API_URL + "/" + venue_id).catch(function (error) {
            axiosErrorHandler(error);
        });
    }

    // no header needed
    getVenuesByCreator(user_id) {
        return axios.get(API_URL + "?offset=0&limit=100&include_total=true&order_by=%2Dupdated_time&creator_id=" + user_id).catch(function (error) {
            axiosErrorHandler(error);
        });
    }

    // header required
    updateVenueNoSlots(venue_id, payload) {
        return axios.patch(API_URL + "/" + venue_id + "/no_slots", payload, axiosAuthHeader()).catch(function (error) {
            axiosErrorHandler(error);
        });
    }

    // header required
    updateVenue(venue_id, payload) {
        return axios.patch(API_URL + "/" + venue_id, payload, axiosAuthHeader()).catch(function (error) {
            axiosErrorHandler(error);
        });
    }

    // header required
    createVenue(payload) {
        return axios.post(API_URL, payload, axiosAuthHeader()).catch(function (error) {
            axiosErrorHandler(error);
        });
    }

    // header required
    deleteVenue(venue_id) {
        return axios.delete(API_URL + "/" + venue_id, axiosAuthHeader()).catch(function (error) {
            axiosErrorHandler(error);
        });
    }
}

export default new VenuesService();
